import { styled } from '../../Styles/stitches.config'

export const StyledList = styled('ol', {
    color: '$primary600',
    fontWeight: 600,
    m: 0,
    pl: 'calc($3 + $1)',
    transition: '$default',
})
